import { render, staticRenderFns } from "./RecommendCatalog.vue?vue&type=template&id=941a3c3e"
import script from "./RecommendCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendCatalog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecommendCatalog.vue?vue&type=style&index=0&id=941a3c3e&prod&setup=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports